import { loadStoredSession } from "@itaas/core/auth/auth.storage";
import { notifyImagingReportReady as notifyImagingReportReadyApi } from "@/core/hospitol-api-client";
import { pushLocalNotification } from "@/core/notifications/local-notifications";
import { routes } from "@/router/all_routes";

/** CR imagerie validé — alerte prescripteur / clinique. */
export async function notifyImagingReportReady(input: {
  examId: string;
  examNumber: string;
  examType: string;
  patientName: string;
}): Promise<void> {
  pushLocalNotification({
    title: "CR imagerie disponible",
    body: `${input.examNumber} — ${input.examType} (${input.patientName})`,
    targetRole: "HOSPITOL_CLINICIAN",
    actionUrl: routes.imagingReports,
    eventType: "imaging.report.ready",
  });

  void notifyImagingReportReadyApi({
    examId: input.examId,
    examNumber: input.examNumber,
    examType: input.examType,
    patientName: input.patientName,
    recipientId: loadStoredSession()?.user?.id,
    tenantId: loadStoredSession()?.tenant?.slug,
  });
}
